﻿{
  "version": 1,
  "gameId": "backgammon",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "cosmetics": {
    "boardThemes": [
      { "id": "classic", "nameKey": "theme.classic", "price": 0, "image": "/assets/boards/Backgammon/board1.jpg" },
      { "id": "golden-leather", "nameKey": "theme.goldenLeather", "price": 120, "image": "/assets/boards/Backgammon/board-golden-leather.jpg" },
      { "id": "walnut-classic", "nameKey": "theme.walnutClassic", "price": 160, "image": "/assets/boards/Backgammon/board-walnut-classic.jpg" },
      { "id": "carved-wood", "nameKey": "theme.carvedWood", "price": 190, "image": "/assets/boards/Backgammon/board-carved-wood.jpg" },
      { "id": "arctic-geo", "nameKey": "theme.arcticGeo", "price": 220, "image": "/assets/boards/Backgammon/board-arctic-geo.jpg" },
      { "id": "navy-club", "nameKey": "theme.navyClub", "price": 240, "image": "/assets/boards/Backgammon/board-navy-club.jpg" },
      { "id": "neon-abyss", "nameKey": "theme.neonAbyss", "price": 360, "image": "/assets/boards/Backgammon/board-neon-abyss.jpg" },
      { "id": "sakura-ink", "nameKey": "theme.sakuraInk", "price": 280, "image": "/assets/boards/Backgammon/board-sakura-ink.jpg" },
      { "id": "ivory-emerald", "nameKey": "theme.ivoryEmerald", "price": 300, "image": "/assets/boards/Backgammon/board-ivory-emerald.jpg" },
      { "id": "marble-rose", "nameKey": "theme.marbleRose", "price": 340, "image": "/assets/boards/Backgammon/board-marble-rose.jpg" },
      { "id": "cream-floral", "nameKey": "theme.creamFloral", "price": 260, "image": "/assets/boards/Backgammon/board-cream-floral.jpg" },
      { "id": "bronze-starlight", "nameKey": "theme.bronzeStarlight", "price": 420, "image": "/assets/boards/Backgammon/board-bronze-starlight.jpg" },
      { "id": "marble-crimson", "nameKey": "theme.marbleCrimson", "price": 380, "image": "/assets/boards/Backgammon/board-marble-crimson.jpg" }
    ]
  },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "backgammon.rules.navigationLabel",
    "kickerKey": "backgammon.rules.kicker",
    "titleKey": "backgammon.rules.title",
    "summaryKey": "backgammon.rules.summary",
    "sections": [
      { "id": "setup", "key": "backgammon.rules.setup" },
      { "id": "movement", "key": "backgammon.rules.movement" },
      { "id": "blocked", "key": "backgammon.rules.blocked" },
      { "id": "hit", "key": "backgammon.rules.hit" },
      { "id": "dice", "key": "backgammon.rules.dice" },
      { "id": "bearing-off", "key": "backgammon.rules.bearingOff" },
      { "id": "finish", "key": "backgammon.rules.finish" }
    ],
    "settingsAccess": false
  }
}
